<div class="wizard-progress" role="progressbar" [attr.aria-label]="ariaLabel()" [attr.aria-valuenow]="currentStep()" [attr.aria-valuemin]="1" [attr.aria-valuemax]="totalSteps()">
  @for (step of steps(); track step.position; let last = $last) {
    <div class="step-container">
      <div class="step" [class.active]="step.isActive" [class.completed]="step.isCompleted" [attr.aria-current]="step.isActive ? 'step' : null"></div>
      @if (!last) {
        <div class="connector" [class.completed]="step.isCompleted"></div>
      }
    </div>
  }
</div>
